import React from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { XCircle, ArrowCounterClockwise } from '@phosphor-icons/react'

const ERROR_MESSAGES: Record<string, string> = {
  TOKEN_MISSING: 'Verification link is invalid or missing token.',
  INVALID_TOKEN: 'This verification link is invalid or has already been used.',
  EXPIRED: 'This verification link has expired. Please request a new one.',
  USER_NOT_FOUND: 'User account not found.',
  ALREADY_VERIFIED: 'Your email is already verified.',
  EMAIL_ALREADY_REGISTERED: 'An account already exists for this email. Please log in instead.',
  UNKNOWN: 'An unknown error occurred. Please try again.',
}

export function EmailVerifyFailedPage() {
  const [searchParams] = useSearchParams()
  const reason = searchParams.get('reason') || 'UNKNOWN'
  const message = ERROR_MESSAGES[reason] || ERROR_MESSAGES.UNKNOWN

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-muted/50 to-background px-4">
      <div className="max-w-md w-full text-center">
        <div className="mb-6 flex justify-center">
          <div className="w-20 h-20 rounded-full bg-red-500/10 flex items-center justify-center">
            <XCircle size={48} weight="fill" className="text-red-500" />
          </div>
        </div>
        
        <h1 className="text-3xl font-bold mb-3">Verification Failed</h1>
        <p className="text-muted-foreground mb-8">
          {message}
        </p>
        
        <div className="space-y-3">
          {reason === 'EXPIRED' && (
            <Link to="/resend-verification" className="block">
              <Button size="lg" className="w-full gap-2">
                <ArrowCounterClockwise size={20} />
                Resend Verification Email
              </Button>
            </Link>
          )}
          
          <Link to="/login" className="block">
            <Button size="lg" variant="outline" className="w-full">
              Go to Login
            </Button>
          </Link>
        </div>
        
        {reason === 'ALREADY_VERIFIED' && (
          <p className="text-sm text-muted-foreground mt-4">
            If you're having trouble logging in, try resetting your password.
          </p>
        )}
      </div>
    </div>
  )
}
